export default __webpack_public_path__ + "static/media/extensionHandle.b49be028.png";